/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef } from 'react';
import lottie from 'lottie-web';
import { CSSProperties } from 'styled-components';

type Props = {
  idTest?: string;
  animation?: Record<string, string | unknown>;
  className?: string;
  style?: CSSProperties;
  loop?: boolean;
};

export const LottieAnimation = ({
  animation,
  className,
  style,
  loop = true,
  idTest,
}: Props) => {
  const innerRef = useRef<HTMLDivElement>(null);

  const renderAnimation = () =>
    lottie.loadAnimation({
      renderer: 'svg',
      loop: loop,
      autoplay: true,
      animationData: animation,
      container: innerRef.current as any,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid meet',
      },
    });

  useEffect(() => {
    renderAnimation();

    return () => lottie.destroy();
  }, [innerRef, animation]);

  return <div className={className} ref={innerRef} style={style} id={idTest} />;
};
